import { passport } from '@imtbl/sdk';
import { config } from './config';

const passportClient = new passport.Passport(config);

(async () => {
  await passportClient.connectEvm();
})();

export type ZkEvmProvider = ReturnType<typeof passportClient.connectEvm>;

export { passportClient };
